import { Injectable, inject } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { LG_AUTHORIZATION_SERVICE } from "@logex/framework/lg-application";

import { LgLoaderService } from "@logex/framework/lg-layout";
import { lastValueFrom } from "rxjs";

import { BootHelperService } from "../helpers/boot-helper.service";

@Injectable({ providedIn: "root" })
export class BootGuardService {
    private _router = inject(Router);
    private _lgLoaderService = inject(LgLoaderService);
    private _bootHelper = inject(BootHelperService);
    private _authorizationService = inject(LG_AUTHORIZATION_SERVICE);

    canActivate(): Promise<boolean | UrlTree> {
        return this._checkAndRedirect();
    }

    private async _checkAndRedirect(): Promise<boolean | UrlTree> {
        if (this._bootHelper.isSessionConfigured()) return true;

        this._lgLoaderService.show("bootGuard");

        try {
            // Check that the user has access to the product instance
            if (!(await lastValueFrom(this._authorizationService.checkProductInstanceAccess()))) {
                // Redirect to "access denied" page
                return this._router.parseUrl("/boot/accessDenied");
            }

            // Access is allowed -> try to select latest stored session
            if (!(await this._bootHelper.trySelectLastSession())) {
                // There is no stored session or it's not available/allowed anymore
                // TODO: Check if user is allowed to switch scenarios
                const dst = this._router.parseUrl("/boot");

                dst.queryParams["redirectTo"] = location.pathname;

                return dst;
            }

            return true;
        } finally {
            this._lgLoaderService.hide("bootGuard");
        }
    }
}
